import { useState, useEffect } from "react";
import { doc, onSnapshot } from "firebase/firestore";
import { db } from "../firebase/config";
import "./milestones.css";

export default function Milestones() {

  // 🔥 default fallback (instant load)
  const defaultData = [
    { year: "2022", title: "Life Time Achievement Award", desc: "Loading..." },
    { year: "2018", title: "Best Author", desc: "Loading..." },
    { year: "2015", title: "Dean", desc: "Loading..." }
  ];

  const [milestones, setMilestones] = useState(defaultData);
  const [showAll, setShowAll] = useState(false);
  const [isMobile, setIsMobile] = useState(false);

  // ================= SCREEN DETECTION =================
  useEffect(() => {
    const checkScreen = () => {
      setIsMobile(window.innerWidth <= 600);
    };

    checkScreen();
    window.addEventListener("resize", checkScreen);

    return () => window.removeEventListener("resize", checkScreen);
  }, []);

  // ================= CACHE + FIRESTORE =================
  useEffect(() => {

    // 🔥 LOAD CACHE FIRST
    const cached = localStorage.getItem("milestonesData");
    if (cached) {
      try {
        setMilestones(JSON.parse(cached));
      } catch (e) {}
    }

    // 🔥 FIRESTORE REALTIME
    const ref = doc(db, "siteContent", "milestones");

    const unsubscribe = onSnapshot(ref, (snap) => {
      if (snap.exists()) {
        const data = snap.data().items || [];

        setMilestones(data);

        // cache it
        localStorage.setItem("milestonesData", JSON.stringify(data));
      }
    });

    return () => unsubscribe();

  }, []);

  // ================= MOBILE LOGIC =================
  const visibleMilestones =
    isMobile && !showAll
      ? milestones.slice(0, 3)
      : milestones;

  return (
    <section className="milestones">
      <div className="milestones-container">

        <h2>Academic Milestones</h2>

        <div className="milestone-cards">
          {visibleMilestones.map((item, index) => (
            <div className="milestone-card" key={index}>
              <span className="year">{item.year}</span>
              <h4>{item.title}</h4>
              <p>{item.desc}</p>
            </div>
          ))}
        </div>

        {/* MOBILE TOGGLE */}
        {isMobile && milestones.length > 3 && (
          <div className="milestone-toggle">
            <button onClick={() => setShowAll(!showAll)}>
              {showAll ? "Read Less ↑" : "Read More ↓"}
            </button>
          </div>
        )}

      </div>
    </section>
  );
}